import React from "react";
import cls from "../../styles/Footer.module.css";
import {
  FcElectronics,
  FcGallery,
  FcLike,
  FcParallelTasks,
  FcViewDetails,
  FcApproval,
  FcBusinesswoman,
  FcAssistant,
  FcEngineering,
  FcImport,
  FcSalesPerformance,
  FcAutomatic,
} from "react-icons/fc";
import { IoMdOpen } from "react-icons/io";
import { NavLink } from "react-router-dom";

const Footer = () => {
  return (
    
    <div className={cls.footer}>
      <div className={cls.listDiv}>
        <li>LonglistName1</li>
        <li>LonglistName2</li>
        <li>LonglistName3</li>
        <li>LonglistName4</li>
        <li>LonglistName1</li>
 
      </div>
      <div className={cls.listDiv}>
        <li>
          <IoMdOpen />
          <NavLink to="/">Contact Developer</NavLink>
        </li>
        <li>
          <IoMdOpen />
          <NavLink to="/">Website Policy</NavLink>
        </li>
        <li>
          <IoMdOpen /><NavLink to="/">Feedback</NavLink>
        </li>
        <li>
          <IoMdOpen />
          <NavLink to="/">Help</NavLink>
        </li>
        <li>
          <IoMdOpen />
          <NavLink to="/">Disclaimer</NavLink>
        </li>
      </div>
      <div className={cls.listDiv}>
        <li>
          <FcViewDetails />
          +91 9999999999
        </li>
        <li>
          <FcApproval />
          +91 9999999999
        </li>
        <li>
          <FcBusinesswoman />
          +91 9999999999
        </li>
        <li>
          <FcAssistant />
          +91 9999999999
        </li>
      </div>
      <div className={cls.listDiv}>
        <li>
          <FcElectronics />
        </li>
        <li>
          <FcGallery />
        </li>
        <li>
          <FcLike />
        </li>
        <li>
          <FcParallelTasks />
        </li>
        <li>
          <FcEngineering />
        </li>
        <li>
          <FcImport />
        </li>
        <li>
          <FcSalesPerformance />
        </li>
        <li>
          <FcAutomatic />
        </li>
      </div>
    </div>
  );
};

export default Footer;
